import React from 'react';
import ProfileDropdown from './ProfileDropdown';

const DropdownSituationActuelle = (props) => {

    const {
        dropdownProps = {}
    } = props;

    return <ProfileDropdown
        {...dropdownProps}
        label="Situation actuelle"
        options={[
            { key: "Locataire", text: "Locataire" },
            { key: "Propriétaire", text: "Propriétaire" }
        ]}
    />;

};

export default DropdownSituationActuelle;